import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classnames from 'classnames';
import { setView } from '@store/policies/precisionPolicy/actions';

import ListIcon from '@icons/policies/list.svg';
import CalenderIcon from '@icons/policies/calendar.svg';
import BackIcon from '@icons/common/back.svg';
import { activeTabSelector } from '@store/policies/schedule/selectors';
import { scheduleViewTabs } from '@store/policies/schedule/utils';
import { setActiveTab } from '@store/policies/schedule/actions';
import { ViewTypes } from '@store/policies/precisionPolicy/reducers';
import { track } from '@utils';
import {
  CLICK_SCHEDULE_POLICY_LIST_VIEW,
  CLICK_SCHEDULE_POLICY_CALENDAR_VIEW,
} from '@src/utils/sensor/track';
import { TopBarWrapper, FlexFill, Title, IconWrap } from './styled';

function TopBar() {
  const dispatch = useDispatch();
  const activeTab = useSelector(activeTabSelector);

  const handleBackButton = () => {
    dispatch(setView(ViewTypes.policies));
  };

  const handleTabChange = (tab) => () => {
    if (tab === scheduleViewTabs.list) {
      track({ event: CLICK_SCHEDULE_POLICY_LIST_VIEW });
    } else {
      track({ event: CLICK_SCHEDULE_POLICY_CALENDAR_VIEW });
    }
    dispatch(setActiveTab(tab));
  };

  return (
    <TopBarWrapper>
      <IconWrap onClick={handleBackButton}>
        <BackIcon />
      </IconWrap>
      <Title> Schedules </Title>
      <FlexFill />
      <IconWrap className={classnames({ selected: activeTab === scheduleViewTabs.list })}>
        <ListIcon onClick={handleTabChange(scheduleViewTabs.list)} />
      </IconWrap>
      <IconWrap className={classnames({ selected: activeTab === scheduleViewTabs.calender })}>
        <CalenderIcon onClick={handleTabChange(scheduleViewTabs.calender)} />
      </IconWrap>
    </TopBarWrapper>
  );
}

export default TopBar;
